module.exports = __webpack_public_path__ + "static/media/cat-lady3W.6521467c.png";